<template>
  <section>
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="status" v-if="isEditable">
      <h2 v-translate>Zdroje obsahu</h2>
      <a
         :title="'Přidat zdroj obsahu' | translate"
          :class="['add', 'add_expand', { open: newContentSourceOpen }, { btn_inactive: false}]"
          @click.prevent="toggleNewContentSource()"
          v-translate>Přidat zdroj obsahu
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: newContentSourceOpen }]" v-if="newContentSourceOpen">
      <div class="field_left">
        <p>
          <select-box
              id="new-content-source-id"
              v-model="newContentSource.id_content_source"
              :options="availableContentSources"
              :required="true"
              ref="localitycontentsourceidref"
          >
            <translate class="translate">Zdroj obsahu</translate>
          </select-box>
        </p>
        <p>
          <text-input
              id="new-content-source-weight"
              v-model="newContentSource.weight"
              :required="true"
              type="number"
              ref="localitycontentsourceweightref"
          >
            <translate class="translate">Váha</translate>
          </text-input>
        </p>
        <p v-if="allowSelectOperator">
          <select-box
              id="operator_content_sources"
              v-model="newContentSource.id_operator"
              :options="operatorOptions"
          >
            <translate class="translate">Operátor</translate>
          </select-box>
        </p>
      </div>
      <div class="field_right field_btn">
        <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addContentSource"
          />
        </p>
      </div>
    </div>

    <table class="vypis vypis_detail">
      <thead class="no_sortable">
      <tr>
        <th v-translate>Zdroj obsahu</th>
        <th v-translate>Operátor</th>
        <th v-translate>Obecný zdroj</th>
        <th v-translate>IP adresa</th>
        <th v-translate>Virtuální zdroj</th>
        <th v-translate>Vytížitelnost zdroje</th>
        <th v-translate>Váha</th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <content-source-row
          v-for="contentSource in contentSourcesPaginated"
          :key="contentSource.id"
          :item="contentSource"
          :isEditable="isEditable"
          @deleteContentSource="deleteContentSource"
          :ref="'localityipprefixrow_'+contentSource.id"
      ></content-source-row>

    </table>
    <list-action-line
        :entities="entities"
        :offset="formFields.offset"
        :limit="formFields.limit"
        :total-count="rowCount"
        @limit="setLimit"
        @offset="setOffset"
        ref="action_line"
    ></list-action-line>
  </section>
</template>
<script>
import ContentSourceRow from "@/components/views/localities/locality/ContentSourceRow";
import listActions from "@/components/mixins/list-actions";
import localities from "../mixins/localities";

export default {
  name: "ContentSourcesList",
  components: {
    ContentSourceRow,
  },
  mixins: [listActions, localities],
  props: {
    isEditable: Boolean,
    locality: Object,
    operatorOptions: Array
  },
  data() {
    return {
      newContentSourceOpen: false,
      newContentSource: {},
      availableContentSources: null,
    };
  },
  created(LocalityService, ContentSourceService) {
    this.entityService = LocalityService;
    this.contentSourceService = ContentSourceService;
  },
  computed: {
    contentSourcesPaginated() {
      if(this.locality.hasOwnProperty('content_sources')) {
        return this.locality['content_sources'].slice(this.formFields.offset, this.formFields.offset + this.formFields.limit);
      }else{
        return [];
      }
    },
    rowCount() {
      if(this.locality.hasOwnProperty('content_sources')) {
        return this.locality['content_sources'].length;
      }else{
        return 0;
      }
    },
    allowSelectOperator(){
      return this.$_createActionAllowedAllOrOwnAndGlobal && this.locality.id_operator == null
    }
  },
  methods: {
    toggleNewContentSource() {
      this.emptyMessage();
      if (!this.newContentSourceOpen) {
        this.newContentSource = {
          id_locality: this.locality.id,
          id_content_source: null,
          weight: null,
          id_operator: this.locality.id_operator,
        };

        this.contentSourceService.getContentSourcesList(this.locality.id_operator)
            .then((data) => {
              this.setAvailableContentSources(data['content_sources']);
              this.newContentSourceOpen = true;
            }).then(()=>{
          this.$refs['localitycontentsourceidref'].setForcedInvalid(false);
          this.$refs['localitycontentsourceidref'].setTouched(false);
          this.$refs['localitycontentsourceweightref'].setForcedInvalid(false);
          this.$refs['localitycontentsourceweightref'].setTouched(false);
        })
            .catch((error) => {
              this.setErrorMessage(error.message);
            });
      }else{
        this.newContentSourceOpen = false;
      }
    },
    setAvailableContentSources(data){
      if (data) {
        let contentSourcesIds = this.locality['content_sources'].map(item =>item.id);
        let tmpData = this._.map(data, function (item) {
             return {id: item['id'], text: item['text']}
        });
        this.availableContentSources = tmpData.filter(item => !contentSourcesIds.includes(item['text']));
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/ContentSourcesList.vue